/* Scoped adapters. No Jackery cart, tracking, account or review scripts. */
(() => {
  'use strict';
  function init(root) {
    if (root.dataset.hp1pAdapterReady) return;
    root.dataset.hp1pAdapterReady = 'true';
    const official = root.querySelector('[data-hp1p-official]');
    if (!official) return;
    official.querySelectorAll('.blocks-tabs-blocks').forEach((block, group) => {
      const list = block.querySelector('.tabs-nav-ul');
      const items = [...block.querySelectorAll('.blocks-tab-item')];
      if (!list || !items.length) return;
      list.replaceChildren();
      const buttons = items.map((item, index) => {
        const button = document.createElement('button');
        button.type = 'button'; button.role = 'tab';
        button.textContent = item.querySelector('.tab-nav')?.textContent.trim() || `View ${index + 1}`;
        const panel = item.querySelector('[role=tabpanel]') || item;
        panel.id = `${root.id}-tab-${group}-${index}`;
        button.setAttribute('aria-controls', panel.id);
        const li = document.createElement('li');li.append(button);list.append(li);
        button.addEventListener('click', () => activate(index));
        button.addEventListener('keydown', event => {
          if (!['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let next = event.key === 'Home' ? 0 : event.key === 'End' ? items.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + items.length) % items.length;
          activate(next);buttons[next].focus();
        });
        return button;
      });
      function activate(index) {
        items.forEach((item, i) => {item.hidden = i !== index;item.classList.remove('invisible');if(i!==index)item.querySelectorAll('video').forEach(v=>v.pause());});
        buttons.forEach((button, i) => {button.setAttribute('aria-selected', String(i === index));button.tabIndex = i === index ? 0 : -1;});
      }
      activate(0);
    });
    const runtime = official.querySelector('[data-hp1p-runtime]');
    if (runtime) {
      const capacity = runtime.querySelector('select'), watts = runtime.querySelector('input'), output = runtime.querySelector('output');
      function calculate() {
        const load = Number(watts.value);
        output.textContent = load > 0 && load <= 1800 ? `${(Number(capacity.value) * .85 / load).toFixed(1)} hours` : 'Enter 1–1,800W';
      }
      runtime.addEventListener('input', calculate);calculate();
    }
    const equipment = {
      basic: ['HomePower 1000 Plus v2 × 1', 'AC Charging Cable × 1'],
      white: ['HomePower 1000 Plus v2 (White) × 1', 'AC Charging Cable × 1'],
      cable: ['HomePower 1000 Plus v2 × 1', 'AC Extension Cable × 1', 'AC Charging Cable × 1'],
      battery: ['HomePower 1000 Plus v2 × 1', 'Battery Pack 2000 Plus v2 × 1', 'AC Charging Cable × 1'],
      batterySolar: ['HomePower 1000 Plus v2 × 1', 'Battery Pack 2000 Plus v2 × 1', 'SolarSaga 200W × 2', 'AC Charging Cable × 1'],
      solar200: ['HomePower 1000 Plus v2 × 1', 'SolarSaga 200W × 1', 'AC Charging Cable × 1']
    };
    function box(key, title) {
      const list = official.querySelector('[data-hp1p-box-items]');
      if (!list) return;
      official.querySelector('[data-hp1p-box-name]').textContent = title || 'HomePower 1000 Plus v2';
      list.replaceChildren(...(equipment[key] || equipment.basic).map(text => {const li = document.createElement('li');li.textContent = text;return li;}));
    }
    root.addEventListener('hp1p:variant', e => box(e.detail.box, e.detail.title));
    const selected = root.querySelector('[data-hp1p-variant].is-selected');
    box(selected?.dataset.box || 'basic', selected?.textContent.trim());
    official.querySelectorAll('[data-hp1p-youtube]').forEach(button => button.addEventListener('click', () => {
      const frame = document.createElement('iframe');
      frame.className = 'hp1p-video-frame';frame.title = 'Official Jackery how-to video';
      frame.src = `https://www.youtube-nocookie.com/embed/${button.dataset.hp1pYoutube}?autoplay=1`;
      frame.allow = 'autoplay; encrypted-media; picture-in-picture';frame.allowFullscreen = true;
      const player = document.createElement('div');player.className = 'hp1p-youtube-player';player.append(frame);
      const link = document.createElement('a');link.className = 'hp1p-youtube-link';link.href = `https://www.youtube.com/watch?v=${button.dataset.hp1pYoutube}`;link.target = '_blank';link.rel = 'noopener';link.textContent = 'Video not playing? Watch on YouTube ↗';
      button.replaceWith(player);player.after(link);
    }));
    official.querySelectorAll('jds-button[label="Watch Video"]').forEach(custom => {
      const source=custom.dataset.videoSrc;
      const poster=custom.dataset.videoPoster;
      if(!source){custom.remove();return;}
      const button=document.createElement('button');button.type='button';button.className='hp1p-watch-video';button.textContent='▶ Watch Video';custom.replaceWith(button);
      button.addEventListener('click',()=>{
        const dialog=document.createElement('dialog');dialog.className='hp1p-video-dialog';const close=document.createElement('button');close.type='button';close.textContent='Close ×';
        const video=document.createElement('video');video.src=source;video.controls=true;video.playsInline=true;video.poster=poster||'';
        const player=document.createElement('div');player.className='hp1p-modal-player';const cover=document.createElement('img');cover.src=poster||'';cover.alt='Official HomePower 1000 Plus v2 product video cover';
        const play=document.createElement('button');play.type='button';play.textContent='▶ Play video';const status=document.createElement('p');status.className='hp1p-video-status';status.role='status';
        const start=()=>{status.textContent='';video.play().catch(()=>{status.textContent='Select Play video to start. If unavailable, please try again later.';});};
        play.addEventListener('click',start);video.addEventListener('playing',()=>{player.classList.add('is-playing');status.textContent='';});video.addEventListener('error',()=>{player.classList.remove('is-playing');status.textContent='Video unavailable. The cover remains visible; select Play video to retry.';});
        close.addEventListener('click',()=>dialog.close());dialog.addEventListener('close',()=>{video.pause();dialog.remove();});player.append(cover,video,play);dialog.append(close,player,status);document.body.append(dialog);dialog.showModal();start();
      });
    });
    official.querySelectorAll('[data-hp1p-open-devices]').forEach(button=>button.addEventListener('click',()=>{
      const dialog=document.getElementById(button.dataset.hp1pOpenDevices);if(dialog){dialog.showModal();dialog.querySelector('[data-hp1p-close]')?.focus();}
    }));
    official.querySelectorAll('[data-hp1p-close]').forEach(button=>button.addEventListener('click',()=>button.closest('dialog').close()));
    official.querySelectorAll('[class^="ai-image-slider-track-"]').forEach(track=>{
      const component=track.closest('[class^="ai-image-slider-container-"]');let index=0;
      const slides=[...track.children];
      const go=step=>{index=(index+step+slides.length)%slides.length;track.scrollTo({left:track.clientWidth*index,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});};
      const previous=component.querySelector('[class*="ai-image-slider-prev-"]'),next=component.querySelector('[class*="ai-image-slider-next-"]');
      if(previous){previous.type='button';previous.setAttribute('aria-label','Previous battery feature');previous.addEventListener('click',()=>go(-1));}
      if(next){next.type='button';next.setAttribute('aria-label','Next battery feature');next.addEventListener('click',()=>go(1));}
      track.tabIndex=0;track.setAttribute('aria-label','Battery features. Scroll horizontally to view more.');track.addEventListener('keydown',e=>{if(['ArrowLeft','ArrowRight'].includes(e.key)){e.preventDefault();go(e.key==='ArrowRight'?1:-1);}});
    });
    official.querySelectorAll('video:not([data-hp1p-route-video])').forEach(video => {
      video.muted = true;video.loop = true;video.controls = true;
      video.addEventListener('error',()=>{if(!video.nextElementSibling?.classList.contains('hp1p-media-failure')){const note=document.createElement('p');note.className='hp1p-media-failure';note.textContent='Video unavailable. Please try again; the cover image remains visible.';video.after(note);}});
      new IntersectionObserver(entries => {
        if (entries[0].isIntersecting && video.getClientRects().length && !matchMedia('(prefers-reduced-motion: reduce)').matches) video.play().catch(() => {});
        else video.pause();
      }, {rootMargin: '0px'}).observe(video);
    });
    official.querySelectorAll('.accordion-title,.accordion-header').forEach(button => {
      const content = button.nextElementSibling;
      if (!content) return;
      button.setAttribute('role', 'button');button.tabIndex = 0;button.setAttribute('aria-expanded', 'true');
      content.style.display = 'block';content.style.height = 'auto';content.style.maxHeight = 'none';
      const toggle = () => {content.hidden = !content.hidden;button.setAttribute('aria-expanded', String(!content.hidden));};
      button.addEventListener('click', toggle);
      button.addEventListener('keydown', e => {if (['Enter', ' '].includes(e.key)) {e.preventDefault();toggle();}});
    });
    // Independent covers remain visible until a selected video is genuinely playing.
    // No dependency on global hidden/lg:block utilities or the source site's scroll runtime.
    official.querySelectorAll('[data-hp1p-routing]').forEach(scene => {
      const panels = [...scene.querySelectorAll('[data-hp1p-stage]')];
      const buttons = [...scene.querySelectorAll('[data-hp1p-route-tab]')];
      const caption = scene.querySelector('[data-hp1p-stage-caption]');
      const status = scene.querySelector('[data-hp1p-route-status]');
      const mobile = matchMedia('(max-width:1023.98px)');
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      let active = 0, inView = false;
      function play(panel, requested = false) {
        const video = panel.querySelector('video');
        if (!video || panel.hidden || (!requested && (reduced.matches || video.dataset.failed))) return;
        const source = mobile.matches ? video.dataset.srcMobile : video.dataset.srcPc;
        const image = panel.querySelector('picture img');
        video.poster = image.currentSrc || image.src;
        if (video.getAttribute('src') !== source) {video.src = source;video.preload = 'metadata';video.load();}
        if (requested) {delete video.dataset.failed;status.textContent = '';}
        video.play().catch(error => {
          panel.classList.remove('is-playing');
          if (!panel.hidden && error.name !== 'AbortError') status.textContent = error.name === 'NotAllowedError' ? 'Select Play video to start.' : 'Video unavailable. The product image remains visible; you can try Play video again.';
        });
      }
      panels.forEach((panel, index) => {
        const video = panel.querySelector('video');if (!video) return;
        video.addEventListener('playing', () => {if (!panel.hidden) {panel.classList.add('is-playing');status.textContent = '';}});
        video.addEventListener('pause', () => panel.classList.remove('is-playing'));
        video.addEventListener('error', () => {video.dataset.failed = 'true';panel.classList.remove('is-playing');if (!panel.hidden) status.textContent = 'Video unavailable. The product image remains visible; you can try Play video again.';});
        panel.querySelector('[data-hp1p-route-play]').addEventListener('click', () => play(panel, true));
        panel.id = `${root.id}-routing-${index}`;
      });
      function activate(index, requested = false) {
        active = index;status.textContent = '';caption.textContent = panels[index].dataset.caption;
        panels.forEach((panel, i) => {panel.hidden = i !== index;if (i !== index) {panel.querySelector('video')?.pause();panel.classList.remove('is-playing');}});
        buttons.forEach((button, i) => {button.setAttribute('aria-selected', String(i === index));button.tabIndex = i === index ? 0 : -1;});
        if (inView || requested) play(panels[index], requested);
      }
      buttons.forEach((button, index) => {
        if (!panels[index].id) panels[index].id = `${root.id}-routing-${index}`;
        button.setAttribute('aria-controls', panels[index].id);panels[index].setAttribute('role', 'tabpanel');
        button.addEventListener('click', () => activate(index, true));
        button.addEventListener('keydown', event => {
          if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault();const next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length;
          activate(next, true);buttons[next].focus();
        });
      });
      new IntersectionObserver(entries => {inView = entries[0].isIntersecting;if (inView) play(panels[active]);else panels.forEach(panel => panel.querySelector('video')?.pause());}, {rootMargin:'0px'}).observe(scene);
      mobile.addEventListener('change', () => {if (inView) play(panels[active]);});
      activate(0);
    });
    root.querySelectorAll('[data-hp1p-mode]').forEach(button => button.addEventListener('click', () => {
      const model = button.dataset.hp1pMode === 'model';
      if (model && location.protocol === 'file:') {
        let note = root.querySelector('[data-hp1p-model-note]');
        if (!note) {note = document.createElement('p');note.dataset.hp1pModelNote = '';note.role = 'status';root.querySelector('.hp1p-gallery__modes').after(note);}
        note.textContent = '3D requires an HTTP preview or the Shopify product page. Photos are available in this local file preview.';
        return;
      }
      root.querySelector('[data-hp1p-model]').hidden = !model;
      root.querySelector('[data-hp1p-zoom]').hidden = model;
      root.querySelectorAll('[data-hp1p-mode]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
      if (model && !customElements.get('model-viewer') && !document.querySelector('[data-hp1p-model-library]')) {
        const script = document.createElement('script');script.src = button.dataset.modelScript;script.dataset.hp1pModelLibrary = 'true';document.head.append(script);
      }
    }));
  }
  const boot = scope => scope.querySelectorAll('[data-hp1p-root]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document)); else boot(document);
  document.addEventListener('shopify:section:load', e => boot(e.target));
})();
